import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/** Ads on Facebook Reels (fullscreen, Android): an ad card over another reel. */
@Component({
  selector: 'app-meta-facebook-reels-overlay-android',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './facebook-reels-overlay-android.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../../preview-common/facebook/facebook-reels-overlay-styles.scss']
})
export class MetaFacebookReelsOverlayAndroidPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;

  /** Both paragraphs on one run; CSS clamps it to the card's lines. */
  get primaryText(): string {
    return MetaPreviewCopy.flat(MetaPreviewCopy.primaryText(this.data));
  }
}
